'use strict';

var fluidconfigure = require('fluidconfigure/fluidconfigure'),
    blucore = require('../bluecore'),
    optinmodal = require('../optinmodal'),
    tagmanager = require('googletags/tagmanager'),
    isStudio = require('../interaction-studio-events'),
    talkablemodal = require('../talkablemodal');

var loadOptInTimeInterval = 2000;

function loadOptInModal(orderNo) {
    if (!SitePreferences.SMS2_ENABLED && !SitePreferences.TALKABLE_POST_CHECKOUT_ENABLED) {
        return;
    }

    var displayOptIn = $('#displayOptIn').length ? $('#displayOptIn').val() : null;
    var serveHotJar = $('#serveHotJar').length ? $('#serveHotJar').val() : null;
    var dismissCheckoutOptIn = Cookies.get('dismissCheckoutOptIn');
    var dismissHotJarCookie = Cookies.get('dismissHotJarCookie');
    var optinType = '';
    if (serveHotJar == 'true' && SitePreferences.SMS2_CONFIRM_HOTJAR_URL && (typeof dismissHotJarCookie == 'undefined' || dismissHotJarCookie == 'false')) {
        optinType = 'hotjar';
    }
    if (displayOptIn == 'true' && (typeof dismissCheckoutOptIn == 'undefined' || dismissCheckoutOptIn == 'false')) {
        optinType = 'checkout';
    }
    if (optinType !== '' && SitePreferences.SMS2_CONFIRM_OPTIN_ENABLED) {
        optinmodal.loadOptIn(null, optinType);
    } else if (SitePreferences.TALKABLE_POST_CHECKOUT_ENABLED) {
        talkablemodal.loadTalkablePostCheckout(orderNo);
    }
}

function sendGA360 () {
    var ga360ConfirmationData = $('#ga360ConfirmationData').length ? $('#ga360ConfirmationData').val() : null;

    if (ga360ConfirmationData && ga360ConfirmationData.length) {
        try {
            ga360ConfirmationData = JSON.parse(ga360ConfirmationData);
        } catch (e) {
            ga360ConfirmationData = null;
        }

        if (ga360ConfirmationData && ga360ConfirmationData !== null) {
            var queryString = window.location.search;

            if (queryString != '') {
                var urlParams = new URLSearchParams(queryString);

                if (urlParams.get('srcCode') != null) {
                    ga360ConfirmationData.ecommerce.affiliation = 'Adobe';
                } else if (urlParams.get('utm_medium') != null) {
                    ga360ConfirmationData.ecommerce.affiliation = 'GTM';
                }
            }

            var emailAddress = $('#transactionalEmail').val();
            if (emailAddress && emailAddress.length) {
                // eslint-disable-next-line camelcase
                ga360ConfirmationData.email_address = emailAddress;
            }
            
            // set product finding methods
            if (ga360ConfirmationData && ga360ConfirmationData.ecommerce && ga360ConfirmationData.ecommerce.items.length  > 0) {
                ga360ConfirmationData.ecommerce.items.forEach((item) => {
                    var itemList = getProductFindingMethod(item.item_id);
                    if (itemList) {
                        item.item_list_id = itemList.itemListId;
                        item.item_list_name = itemList.itemListName;
                        item.item_tile = itemList.itemTile;
                        item.item_image_setup = itemList.itemImageSetup;
                        item.item_image_type = itemList.itemImageType;
                    }
                });
            }

            tagmanager.pushToDataLayer({ecommerce: null});
            tagmanager.pushToDataLayer(ga360ConfirmationData);
        }
    }
}


function getProductFindingMethods () {
    try {
        return JSON.parse(sessionStorage.getItem('mw_pfm') || '{}');
    } catch (e) {
        return {};
    }
}

function getProductFindingMethod (itemId) {
    const productFindingMethods = getProductFindingMethods();
    const [listId, listName, itemTile, itemImageSetup, itemImageType] = productFindingMethods[itemId] || [];
    return {
        itemListId: listId || undefined,
        itemListName: listName || undefined,
        itemTile: itemTile || undefined,
        itemImageSetup: itemImageSetup || undefined,
        itemImageType: itemImageType || undefined,
    }
}

exports.init = function () {
    var orderNumber = $('.value.order-num').length > 0 ? $('.value.order-num').text() : '';
    if (SitePreferences.SMS2_CONFIRM_OPTIN_ENABLED || SitePreferences.TALKABLE_POST_CHECKOUT_ENABLED) {
        setTimeout(loadOptInModal(orderNumber), loadOptInTimeInterval);
    }
    var confirmationDetails = $('input[name=confirmationDetails]').val() || '';
    if (confirmationDetails !== undefined && confirmationDetails !== null && confirmationDetails !== '') {
        try {
            confirmationDetails = JSON.parse(confirmationDetails);
        } catch (error) {
            confirmationDetails = {
                page: {
                    orderNumber: orderNumber
                },
                products: []
            };
        }
        isStudio.sendOrderConfirmation(confirmationDetails);
    }

    $(function() {
        sendGA360();
    });

    fluidconfigure.initOrderDetailsLineItems();
    blucore.pushTransactionalEmail();
}
